import { ResponsePaging } from './../../nest-responses';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class SfAttendanceApi {

  private service: string = '';
  private model: string = 'SFAttendance';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getEmployee(payload: { keyword: string, limit: string, offset: string }): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getEmployee';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<{
      "userId": number,
      "empId": string,
      "empNo": string,
      "posNameEn": string,
      "photo": string
    }[]
    >>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-attendance.ts